import React from 'react';
import { SystemIcon } from '@monorepo/nova-icons';
import { StyledIconPreloader } from '../styled';
import { useIconPreloader } from '../../hooks';

export const IconPreloader: React.FC = () => {
  const iconsPreloaded = useIconPreloader();

  if (!iconsPreloaded) return null;

  return (
    <StyledIconPreloader>
      <SystemIcon iconName="Search" />
      <SystemIcon iconName="X" />
      <SystemIcon iconName="FunnelSimple" />
      <SystemIcon iconName="FunnelSimpleX" />
      <SystemIcon iconName="ColumnsPlusRight" />
      <SystemIcon iconName="ColumnsPlusRightClose" />
      <SystemIcon iconName="CornersOut" />
      <SystemIcon iconName="FullscreenExit" />
      <SystemIcon iconName="List" />
      <SystemIcon iconName="SquaresFour" />
      <SystemIcon iconName="Check" />
    </StyledIconPreloader>
  );
};
